import React from 'react';
import { Form, Button, DatePicker, message, Input } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { DATE_FORMAT } from '~commons/constants';

const OilPricesForm = ({ fields, isNew, id, dataSelect, reload, onChange, setLoading }) => {
  const handleCreate = async (data) => {
    data.companyId = JSON.parse(localStorage.getItem('user_data_decode_token_tms'))?.CompanyId;

    try {
      const res = await ApiServices.createDissolveLock(data);
      if (res?.data?.data) {
        message.success('Thêm mới Khoá giải trừ thành công');
        return reload();
      } else {
        message.error('Thêm mới Khoá giải trừ thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới Khoá giải trừ thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const handleUpdate = async (data) => {
    data.id = id;
    data.companyId = dataSelect.companyId;
    try {
      const res = await ApiServices.updateDissolveLock(id, data);
      if (res.data) {
        message.success('Cập nhật Khoá giải trừ thành công');
        return reload();
      } else {
        message.error('Cập nhật Khoá giải trừ thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Khoá giải trừ thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await handleCreate(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await handleUpdate(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      className='form-input-data'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        name='beginDate'
        label='Ngày bắt đầu'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn ngày bắt đầu',
          },
        ]}
      >
        <DatePicker placeholder='Ngày bắt đầu' style={{ width: '100%' }} format={DATE_FORMAT} />
      </Form.Item>
      <Form.Item
        name='endDate'
        label='Ngày kết thúc'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn ngày kết thúc',
          },
        ]}
      >
        <DatePicker placeholder='Ngày kết thúc' style={{ width: '100%' }} format={DATE_FORMAT} />
      </Form.Item>
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='note'
        label='Ghi chứ'
      >
        <Input placeholder='Vui lòng nhập ghi chú' />
      </Form.Item>
      <Form.Item {...tailLayout} className='submit-form-input-data'>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { OilPricesForm };
